import { IconStarFilled } from '@tabler/icons-react';

interface Props {
  max: number;
  value: number;
}

export const StarRating: React.FC<Props> = ({ max, value }) => {
  const starValue = value >= 0 ? Math.min(max, value) : 0;

  const STAR_TYPES = {
    selected: 'text-tertiary',
    unselected: 'text-neutral-100',
  };

  return (
    <span className="flex gap-1">
      {Array(max)
        .fill('unselected')
        .map((_, idx) => (idx + 1 <= starValue ? 'selected' : 'unselected'))
        .map((starType, idx) => (
          <IconStarFilled key={`star_${idx}`} className={`${STAR_TYPES[starType]}`} width={20} height={20} />
        ))}
    </span>
  );
};
